module.exports = __webpack_public_path__ + "img/pluto150.b734856c.jpg";